import { EnumOf } from "../types/UtilTypes";

export const AuthLevel = {
	USER: 10,
	MANAGER: 20,
	ADMIN: 30,
	SALES_ADMIN: 35,
	SUPER_ADMIN: 40,
} as const;
export type AuthLevel = EnumOf<typeof AuthLevel>;
